__turbopack_context__.v({
  "collapsed": "hyA3wq_collapsed",
  "header": "hyA3wq_header",
  "inviteButton": "hyA3wq_inviteButton",
  "logo": "hyA3wq_logo",
  "navPanel": "hyA3wq_navPanel",
  "navPanelNoIcons": "hyA3wq_navPanelNoIcons",
  "navPanelWrapper": "hyA3wq_navPanelWrapper",
  "panelContent": "hyA3wq_panelContent",
  "sidebarNav": "hyA3wq_sidebarNav",
  "toggleIcon": "hyA3wq_toggleIcon",
  "wrapper": "hyA3wq_wrapper",
});
